import { Directive, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { Log } from 'src/app/core/console.log';
import { ScreenName } from 'src/app/shared/display/screen.name';
import { ScreenService } from './screen.service';

@Directive({
  selector: '[appScreenResize]'
})
export class ScreenResizeDirective implements OnInit {
  public sizeName: ScreenName;
  @Output() sizeChanged: EventEmitter<ScreenName> = new EventEmitter();

  constructor(private screenService: ScreenService) { }

  ngOnInit(): void {
    this.displayCurrentSize(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  handleResize(event) {
    this.displayCurrentSize(event.target.innerWidth);
  }

  private displayCurrentSize(width) {
    const size = this.screenService.checkSizeScreen(width);
    if (this.sizeName !== size) {
      this.sizeName = size;
      this.sizeChanged.emit(this.sizeName);
      Log.debug('current.size: ' + size);
    }
  }
}
